/* MM / Panneau boutiques — assets/mm-store-panel.js
   Synchronisation du slider de la bottom sheet mobile : les dots suivent le
   scroll-snap de la piste (rAF, pas de scroll-jack), un tap sur un dot glisse
   vers la carte (MmMotion.glideTo si dispo — la glisse à la courbe du kit —,
   repli scrollTo smooth). L'ouverture/fermeture du panneau vit dans
   mm-panel.js. Idempotent (garde data-mm-stpanel-ready) : les previews
   ré-exécutent les scripts. */
   (function () {
	'use strict';
  
	function init(root) {
	  if (root.dataset.mmStpanelReady === 'true') return;
	  root.dataset.mmStpanelReady = 'true';
  
	  var track = root.querySelector('[data-stpanel-track]');
	  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-stpanel-dot]'));
	  if (!track || !dots.length) return;
  
	  /* offsetLeft des cellules relatif à la PISTE, pas au panneau fixed
		 (sinon le padding du corps de la sheet biaise toutes les cibles de
		 12px) — même parade que MmMotion.dragScroll */
	  if (getComputedStyle(track).position === 'static') track.style.position = 'relative';
  
	  /* le doigt reprend la main : un tween de glisse en cours est stoppé net
		 (sinon il continue d'écrire scrollLeft et se bat avec le scroll natif) */
	  track.addEventListener('touchstart', function () {
		if (window.MmMotion && MmMotion.glideStop) MmMotion.glideStop(track);
	  }, { passive: true });
  
	  /* drag premium du kit sur le slider de la sheet (retour Killian 31/07 :
		 le slider doit fonctionner au drag) : suivi amorti + relâchement step
		 by step, actif seulement quand la grille est devenue une piste
		 (display flex sous 750px — en grid desktop, pas de drag) */
	  if (window.MmMotion && MmMotion.dragScroll) {
		MmMotion.dragScroll(track, {
		  align: 'start',
		  enabled: function () { return getComputedStyle(track).display !== 'grid'; }
		});
	  }
  
	  function cells() {
		return Array.prototype.slice.call(track.children);
	  }
  
	  function setActive(i) {
		dots.forEach(function (dot, j) {
		  dot.classList.toggle('is-active', j === i);
		});
	  }
  
	  /* le dot actif = la cellule la plus proche du bord gauche de la piste */
	  var raf = 0;
	  track.addEventListener('scroll', function () {
		if (raf) return;
		raf = requestAnimationFrame(function () {
		  raf = 0;
		  var left = track.scrollLeft;
		  var best = 0;
		  var bestDist = Infinity;
		  cells().forEach(function (cell, i) {
			var d = Math.abs(cell.offsetLeft - left);
			if (d < bestDist) { bestDist = d; best = i; }
		  });
		  setActive(best);
		});
	  }, { passive: true });
  
	  dots.forEach(function (dot, i) {
		dot.addEventListener('click', function () {
		  var cell = cells()[i];
		  if (!cell) return;
		  /* cible bornée au scroll maximum (pattern dragScroll) */
		  var max = track.scrollWidth - track.clientWidth;
		  var target = Math.min(Math.max(cell.offsetLeft, 0), max);
		  if (window.MmMotion && MmMotion.glideTo) {
			MmMotion.glideTo(track, target);
		  } else {
			track.scrollTo({ left: target, behavior: 'smooth' });
		  }
		});
	  });
	}
  
	/* ---- Statut ouvert/fermé (calculé ici, PAS en Liquid serveur : le cache
	   CDN figerait un statut périmé) ----------------------------------------
	   data-mm-hours = JSON [{day, morning_open, morning_close, afternoon_open,
	   afternoon_close}], day aligné sur le champ 'day' du metaobject
	   store_hours_day (1=Lundi...6=Samedi). Le dimanche n'a jamais d'entrée :
	   fermeture codée en dur (décision produit, pas de champ à chercher). */
	function parseHours(el) {
	  var raw = el.getAttribute('data-mm-hours');
	  if (!raw) return [];
	  try {
		return JSON.parse(raw);
	  } catch (e) {
		window.log && window.log('warn', '🏬 [STORE_PANEL]', 'data-mm-hours JSON invalide', raw);
		return [];
	  }
	}

	/* 'HH:MM' -> minutes depuis minuit ; vide/invalide -> null (créneau absent) */
	function toMinutes(hhmm) {
	  var match = /^(\d{1,2})(?:[h:.](\d{2})?)?$/i.exec(String(hhmm || '').trim());
	  if (!match) return null;
	  var h = parseInt(match[1], 10);
	  var m = match[2] ? parseInt(match[2], 10) : 0;
	  if (h > 24 || m > 59) return null;
	  return (h * 60) + m;
	}

	function parisClock(now) {
	  try {
		var parts = {};
		new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
		  .formatToParts(now)
		  .forEach(function (part) { parts[part.type] = part.value; });
		var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
		var minutes = ((parseInt(parts.hour, 10) % 24) * 60) + parseInt(parts.minute, 10);
		if (day !== -1 && !isNaN(minutes)) return { day: day, minutes: minutes };
	  } catch (e) {}
	  return { day: now.getDay(), minutes: (now.getHours() * 60) + now.getMinutes() };
	}

	function minutesToLabel(totalMinutes) {
	  var h = Math.floor(totalMinutes / 60);
	  var m = totalMinutes % 60;
	  return m === 0 ? (h + 'h') : (h + 'h' + (m < 10 ? '0' + m : m));
	}

	/* Retourne { open, sunday, nextLabel: 'closes_at'|'opens_at'|null, nextTime } */
	function computeStatus(hoursArray, now) {
	  var clock = parisClock(now);
	  var jsDay = clock.day; /* 0 = dimanche ... 6 = samedi */
	  if (jsDay === 0) {
		return { open: false, sunday: true, nextLabel: null, nextTime: null };
	  }

	  var today = null;
	  for (var i = 0; i < hoursArray.length; i++) {
		if (hoursArray[i].day === jsDay) { today = hoursArray[i]; break; }
	  }
	  if (!today) {
		return { open: false, sunday: false, nextLabel: null, nextTime: null };
	  }

	  var nowMin = clock.minutes;
	  var morningClose = toMinutes(today.morning_close);
	  var afternoonOpen = toMinutes(today.afternoon_open);
	  var afternoonClose = toMinutes(today.afternoon_close);
	  if (morningClose === null && afternoonOpen === null) {
		morningClose = afternoonClose;
		afternoonClose = null;
	  }
	  var slots = [
		{ open: toMinutes(today.morning_open), close: morningClose },
		{ open: afternoonOpen, close: afternoonClose }
	  ];

	  for (var s = 0; s < slots.length; s++) {
		var slot = slots[s];
		if (slot.open === null || slot.close === null) continue;
		if (nowMin >= slot.open && nowMin < slot.close) {
		  return { open: true, sunday: false, nextLabel: 'closes_at', nextTime: minutesToLabel(slot.close) };
		}
	  }

	  for (var n = 0; n < slots.length; n++) {
		var upcoming = slots[n];
		if (upcoming.open !== null && nowMin < upcoming.open) {
		  return { open: false, sunday: false, nextLabel: 'opens_at', nextTime: minutesToLabel(upcoming.open) };
		}
	  }

	  return { open: false, sunday: false, nextLabel: null, nextTime: null };
	}

	/* Assemble le texte final depuis les data-label-* (déjà traduits par
	   Liquid) + l'heure calculée — aucun mot en dur ici, seul '[heure]' est un
	   placeholder maison remplacé dans la traduction (à ne pas confondre avec
	   l'interpolation native Shopify {{ }} utilisée ailleurs). */
	function renderStatus(el) {
	  /* override BO (ex. "Sur rendez-vous") : remplace TOUT l'affichage — pas
		 de calcul horaire, pas de ligne d'horaire à côté. Toujours vert
		 (mm-label-stock), même si hors créneaux ce jour-là. */
	  var override = el.getAttribute('data-status-override');
	  if (override) {
		el.innerHTML = '<p class="mm-label mm-cursor-default mm-label-stock mm-scard__open"><span class="mm-label-text"></span></p>';
		el.querySelector('.mm-label-text').textContent = override;
		return;
	  }

	  var hours = parseHours(el);
	  var status = computeStatus(hours, new Date());

	  var labelOpen = el.getAttribute('data-label-open');
	  var labelClosed = el.getAttribute('data-label-closed');
	  var labelClosesAt = el.getAttribute('data-label-closes-at');
	  var labelOpensAt = el.getAttribute('data-label-opens-at');
	  var labelSundayClosed = el.getAttribute('data-label-sunday-closed');

	  /* markup identique au COMPOSANT mm-label (snippets/mm-label.liquid) :
		 <p class="mm-label mm-cursor-default {variant}"><span class="mm-label-text">...</span></p> */
	  var pillClass = status.open ? 'mm-label mm-cursor-default mm-label-stock mm-scard__open' : 'mm-label mm-cursor-default mm-label-stock-off mm-scard__open';
	  var pillText = status.open ? labelOpen : labelClosed;

	  var hoursText = '';
	  if (status.sunday) {
		hoursText = labelSundayClosed;
	  } else if (status.nextLabel === 'closes_at') {
		hoursText = labelClosesAt.replace('[heure]', status.nextTime);
	  } else if (status.nextLabel === 'opens_at') {
		hoursText = labelOpensAt.replace('[heure]', status.nextTime);
	  }

	  el.innerHTML =
		'<p class="' + pillClass + '"><span class="mm-label-text">' + pillText + '</span></p>' +
		(hoursText ? '<span class="mm-scard__hours">' + hoursText + '</span>' : '');
	}

	function initStatuses(scope) {
	  (scope || document).querySelectorAll('[data-mm-store-status]').forEach(renderStatus);
	}

	function setup(scope) {
	  (scope || document).querySelectorAll('.mm-stpanel').forEach(init);
	  initStatuses(scope);
	}

	window.MmStorePanel = { setup: setup };

	if (document.readyState === 'loading') {
	  document.addEventListener('DOMContentLoaded', function () { setup(); });
	} else {
	  setup();
	}

	/* .mm-stpanel est un [data-product-reload] (stock par boutique dépendant
	   du variant sélectionné) : le swap outerHTML remplace tout le panneau par
	   du HTML neuf jamais passé par init() ci-dessus — sans ce ré-appel, dots
	   et drag du slider mobile restent silencieux et le statut ouvert/fermé
	   ne se calcule jamais (même piège que sticky-cta, cf. product-reload). */
	document.addEventListener('product:product-reload-complete', function () {
	  setup();
	});
  })();